
import { getBaseUrl, request } from 'src/helpers/thunkApi';

const BASE_URL = `${getBaseUrl()}/quote-v2`;

export const fetchQuoteDetails = (id: string) => request({
  method: 'GET',
  url: `${BASE_URL}/details/${id}`,
  contentType: 'json',
  // Sends the admin session cookie, so an admin previewing the quote is not recorded as the customer viewing it.
  withCredentials: true,
}, 'quoteDetails');

export const fetchQuotePartnerEvent = (id: string) => request({
  method: 'GET',
  url: `${BASE_URL}/partner-event/${id}`,
  contentType: 'json',
}, 'quotePartnerEvent');

export const fetchQuoteHistory = (id: string) => request({
  method: 'GET',
  url: `${BASE_URL}/history/${id}`,
  contentType: 'json',
}, 'quoteHistory');

export const approveQuote = (id: string) => request({
  method: 'POST',
  url: `${BASE_URL}/approve/${id}`,
  contentType: 'json',
}, 'approveQuote');

export const rejectQuote = (id: string) => request({
  method: 'POST',
  url: `${BASE_URL}/reject/${id}`,
  contentType: 'json',
}, 'rejectQuote');

// PYR-227 — Quote Review reject/revise. Both route to the Quotes team and do not
// notify the Pro at submit (Pro is notified only after an admin confirms).
export const reviewReject = (id: string) => request({
  method: 'POST',
  url: `${BASE_URL}/review/reject/${id}`,
  contentType: 'json',
}, 'reviewReject');

export const reviewRevise = (id: string) => request({
  method: 'POST',
  url: `${BASE_URL}/review/revise/${id}`,
  contentType: 'json',
}, 'reviewRevise');

export type QuoteMediaGroup = 'hvac-photos' | 'quote-justification-media' | 'task-attachments';

// The task or appliance id goes in the payload as query params (axios leaves out empty ones).
export const downloadQuoteMedia = (id: string, group: QuoteMediaGroup) => request({
  method: 'GET',
  url: `${BASE_URL}/media/${id}/${group}/download`,
  contentType: 'json',
}, 'downloadQuoteMedia');

export const needMoreTime = (id: string, params?: Record<string, unknown>) => request({
  method: 'POST',
  url: `${BASE_URL}/need-more-time/${id}`,
  contentType: 'json',
  data: params,
}, 'needMoreTime');

export const fetchMrQuoteDetails = (id: string, params?: Record<string, unknown>) => request({
  method: 'GET',
  url: `${BASE_URL}/make-ready-quote/${id}`,
  contentType: 'json',
  data: params,
}, 'mrQuoteDetails');

export const mrQuoteApprove = (id: string) => request({
  method: 'POST',
  url: `${BASE_URL}/make-ready-quote-approve/${id}`,
  contentType: 'json',
}, 'mrQuoteApprove');

export const mrQuoteReject = (id: string) => request({
  method: 'POST',
  url: `${BASE_URL}/make-ready-quote-reject/${id}`,
  contentType: 'json',
}, 'mrQuoteReject');
